/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryModel } from '../../models/category-model';

export interface CategoryIdGet$Json$Params {
  id: string;
}

export function categoryIdGet$Json(http: HttpClient, rootUrl: string, params: CategoryIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategoryModel>> {
  const rb = new RequestBuilder(rootUrl, categoryIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<CategoryModel>;
    })
  );
}

categoryIdGet$Json.PATH = '/Category/{id}';
